/**
 * グローバルナビゲーションを管理するクラス。
 */
export class Gnav {
    /**
     * Gnavのインスタンスを作成。
     */
    constructor() {
        /**
         * ハンバーガーメニューのボタン要素。
         * @type {jQuery}
         * @private
         */
        this.$hamberger = $('.js-hamb_wrap');

        /**
         * ハンバーガーメニュー内のリンク要素。
         * @type {jQuery}
         * @private
         */
        this.$links = $('.js-second_nav').find('a');

        /**
         * ハンバーガーメニューが開いた状態かどうか。
         * @type {boolean}
         * @private
         */
        this.isMenuOpen = false;

        this._init();
    }

    /**
     * 初期設定を行います。
     * @private
     */
    _init() {
        // ハンバーガーメニューのクリックイベントを設定
        this.$hamberger.off('click').on('click', () => this._toggleMenu());

        // ハンバーガーメニュー内のリンククリック時にメニューを閉じる
        this.$links.off('click').on('click', () => this._closeMenu());

        // pjax遷移後にメニューを閉じる
        $(document).off('pjax:end').on('pjax:end', () => this._closeMenu());

        // グローバルナビのメガメニュー：リンククリックで閉じる
        this._initMegaMenu();
    }

    /**
     * グローバルナビのメガメニュー処理。
     * リンククリック時に is-closed クラスでhover表示を抑制し、
     * マウスが項目から離れたら通常のhover挙動へ戻す。
     * サブメニューの left を実測でクランプし、ビューポート内に収める。
     * @private
     */
    _initMegaMenu() {
        const $items = $('.l-header_gnav_item_has_submenu');

        $items.off('click.megamenu').on('click.megamenu', 'a', function () {
            const $item = $(this).closest('.l-header_gnav_item_has_submenu');
            $item.addClass('is-closed');
        });

        $items.off('mouseleave.megamenu').on('mouseleave.megamenu', function () {
            $(this).removeClass('is-closed');
        });

        this._alignMegaMenus($items);
        $(window).off('resize.megamenu').on('resize.megamenu', () => this._alignMegaMenus($items));
    }

    /**
     * 各サブメニューの left を項目位置とビューポート幅から計算し、両端が見切れないようクランプする。
     * @param {jQuery} $items サブメニューを持つナビ項目群
     * @private
     */
    _alignMegaMenus($items) {
        const viewportPadding = 40;
        const viewportWidth = window.innerWidth;

        $items.each(function () {
            const $item = $(this);
            const $submenu = $item.children('.l-header_gnav_submenu');
            const $inner = $submenu.find('.l-header_gnav_submenu_inner');
            if (!$inner.length) return;

            // 一旦インラインstyleをリセットしてから実測
            $submenu.css('left', '');

            const itemLeft = $item.offset().left;
            const submenuWidth = $inner.outerWidth();

            // 理想はサブメニュー左端 = 項目左端。ただし左右のviewportPadding内に収める
            let desiredLeft = itemLeft;
            const maxLeft = viewportWidth - viewportPadding - submenuWidth;
            if (desiredLeft > maxLeft) desiredLeft = maxLeft;
            if (desiredLeft < viewportPadding) desiredLeft = viewportPadding;

            $submenu.css('left', `${desiredLeft - itemLeft}px`);
        });
    }

    /**
     * ハンバーガーメニューの開閉を切り替える。
     * @private
     */
    _toggleMenu() {
        this.isMenuOpen = !this.isMenuOpen;

        // メニューの開閉状態に応じてクラスを切り替える
        this.$hamberger.toggleClass('is-menuopen', this.isMenuOpen);

        if (this.isMenuOpen) {
            $('.second_nav').fadeIn();
            $('.l-header_gnav').fadeOut();
            $('.js-hamb_text').text('CLOSE');
        } else {
            this._closeMenu();
            $('.js-hamb_text').text('MENU');
        }
    }

    /**
     * ハンバーガーメニューを閉じる。
     * @private
     */
    _closeMenu() {
        this.isMenuOpen = false;

        // メニューを閉じる際のクラスと表示を切り替える
        this.$hamberger.removeClass('is-menuopen');
        $('.second_nav').fadeOut();
        $('.l-header_gnav').fadeIn();
    }
}